import React, { FC, ReactElement } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import mainImage from "../../assets/mainImage.png";
import mainImage2 from "../../assets/mainImage2.png";
import mainImage3 from "../../assets/mainImage3.png";
import playButton from "../../assets/playButton.png";

import { Button, Box, Link } from "@mui/material";

import { RangeContainer, TimeRange, Title } from "./carousel.styled";
import General from '../../stores/GeneralStore'

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./styles.css";

// import required modules
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";

const Carousel: FC = (): ReactElement => {
  // const [val, setVal] = React.useState<number>(0);
  // const [val1, setVal1] = React.useState<number>(3);
  // const [val2, setVal2] = React.useState<number>(6);

  // function changeValues() {
  //   for (let i = 0; i <= 3; i++) {
  //     setTimeout(() => {
  //       setVal(val + 1);
  //     }, 1000);
  //   }
  // }

  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
        navigation={true}
        className="mySwiper"
        autoplay={{
          delay: 3000,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        }}
        loop={true}
        speed={500}
      >
        <SwiperSlide className="mySwiper">
          <img src={mainImage} alt="Logo" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={mainImage2} alt="Logo" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={mainImage3} alt="Logo" />
        </SwiperSlide>
      </Swiper>
      <Box
        sx={{ position: "absolute", left: "140px", top: "310px", zIndex: 2 }}
        display={{ xs: "none", sm: "none", md: "flex" }}
      >
        <Box
          component="div"
          sx={{ display: "flex", flexDirection: "column", gap: "3rem" }}
        >
          <Title>Transforming Water</Title>
          <Title>to H2ALL</Title>
          <Box
            sx={{ borderRadius: "none" }}
            display="flex"
            gap={"20px"}
            alignItems="center"
          >
            <Button
              sx={{
                backgroundColor: "#62AA51",
                borderRadius: "0",
                fontWeight: "bold",
                paddingY: "0.7rem",
              }}
              variant="contained"
            >
              ABOUT ASPCL
            </Button>
            <Link href="#" sx={{ paddingBottom: ".2rem", textDecoration:"none" }}>
              <img
                className="watchVideo"
                src={playButton}
                style={{ verticalAlign: "middle" }}
                alt=""
              />
              <span style={{ color: "white",}}>WATCH VIDEO</span>
            </Link>
          </Box>
          <RangeContainer>
            <TimeRange type="range" defaultValue={2} min={0} max={3} />
            <TimeRange type="range" defaultValue={3} min={3} max={6} />
            <TimeRange type="range" defaultValue={6} min={6} max={9} />
          </RangeContainer>
        </Box>
      </Box>
    </>
  );
};

export default Carousel;
